module.exports = __webpack_public_path__ + "assets/instruction-kyc.gif";